import React from "react";
import ReactDOM from "react-dom";

import MagazineGate from "./MagazineGate";

const magazineGates = document.getElementsByClassName("MagazineGate");

if (magazineGates) {
  for (let i = 0; i < magazineGates.length; i++) {
    ReactDOM.render(
      <MagazineGate
        text={magazineGates[i].dataset.text}
        classes={magazineGates[i].dataset.classes}
        glyph={magazineGates[i].dataset.glyph}
        redirectUrl={magazineGates[i].dataset.redirecturl}
        sitename={magazineGates[i].dataset.sitename}
      />,
      magazineGates[i]
    );
  }
}
